/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import PubSub from 'pubsub-js';
import keyboard from 'keycode-ui';

const deps = {};
/*---------------------------------------------------------*\
 * News12Ad
\*---------------------------------------------------------*/
class News12AdController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($scope, $timeout, $state, $stateParams, states, topics, adService) {
    this.name = 'news12Ad';
    deps.adService = adService;
    deps.$timeout = $timeout;
    deps.$state = $state;
    deps.$stateParams = $stateParams;
    deps.states = states;
    deps.topics = topics;
    deps.$scope = $scope;

    this.init();
    this.ad = {};

    const token1 = PubSub.subscribe(deps.topics.ads.refreshAd, () => {
      // on menu select, re-intialize ads again
      this.init();
    });

    deps.$scope.$on('$destroy', () => {
      PubSub.unsubscribe(token1);
    });
  }

  //-----------------------------------
  // Properties
  //-----------------------------------

  //-----------------------------------
  // Methods
  //-----------------------------------
  init() {
    deps.adService.getAd(this.section, this.adLocation, this.region.abbr)
      .then((data) => {
        deps.$timeout(() => {
          this.ad = data;
        });
      });
  }

  showAd() {
    if (this.ad && this.ad.onclick && this.ad.onclick.vod) {
      const ad = {
        src: this.ad.onclick.vod
      };
      deps.$state.go(deps.states.videoplayer, { ad }, { location: true });
    }
  }
  //-----------------------------------
  // Events
  //-----------------------------------
  select(e, item) {
    if (keyboard.isEnter(e)) {
      this.showAd(this);
    } else {
      this.onAdSelect({
        event: e,
        location: item
      });
    }
  }
}

News12AdController.$inject = ['$scope', '$timeout', '$state', '$stateParams', 'states', 'topics', 'adService'];

export default News12AdController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/news12Ad/news12Ad.controller.js
 **/